import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PlanSelection } from './components/PlanSelection';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
import { Dashboard } from './components/dashboard/Dashboard';
import { ContactUs } from './pages/ContactUs';
import { HelpCenter } from './pages/HelpCenter';
import { InstallationGuide } from './pages/InstallationGuide';
import { TermsAndPrivacy } from './pages/TermsAndPrivacy';
import { RefundPolicy } from './pages/RefundPolicy';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
export function App() {
  return <BrowserRouter data-id="element-24">
      <Routes data-id="element-25">
        <Route path="/" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-27">
              <Navbar data-id="element-28" />
              <main data-id="element-29">
                <HeroSection data-id="element-30" />
                <PlanSelection data-id="element-31" />
                <HowItWorks data-id="element-32" />
                <FAQ data-id="element-33" />
                <TrustSection data-id="element-34" />
              </main>
              <Footer data-id="element-35" />
            </div>} data-id="element-26" />
        <Route path="/dashboard/*" element={<Dashboard data-id="element-37" />} data-id="element-36" />
        <Route path="/contact" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-39">
              <Navbar data-id="element-40" />
              <ContactUs data-id="element-41" />
              <Footer data-id="element-42" />
            </div>} data-id="element-38" />
        <Route path="/help" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-44">
              <Navbar data-id="element-45" />
              <HelpCenter data-id="element-46" />
              <Footer data-id="element-47" />
            </div>} data-id="element-43" />
        <Route path="/installation-guide" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-49">
              <Navbar data-id="element-50" />
              <InstallationGuide data-id="element-51" />
              <Footer data-id="element-52" />
            </div>} data-id="element-48" />
        <Route path="/terms-privacy" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-54">
              <Navbar data-id="element-55" />
              <TermsAndPrivacy data-id="element-56" />
              <Footer data-id="element-57" />
            </div>} data-id="element-53" />
        <Route path="/refund-policy" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-59">
              <Navbar data-id="element-60" />
              <RefundPolicy data-id="element-61" />
              <Footer data-id="element-62" />
            </div>} data-id="element-58" />
        <Route path="/blog" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-64">
              <Navbar data-id="element-65" />
              <Blog data-id="element-66" />
              <Footer data-id="element-67" />
            </div>} data-id="element-63" />
        <Route path="/blog/:id" element={<div className="min-h-screen bg-[#F9FAFB] font-[Inter] text-[#111827]" data-id="element-69">
              <Navbar data-id="element-70" />
              <BlogPost data-id="element-71" />
              <Footer data-id="element-72" />
            </div>} data-id="element-68" />
      </Routes>
    </BrowserRouter>;
}